import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-rc-professionnelle',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent],
  templateUrl: './assurance-rc-professionnelle.component.html',
  styleUrl: './assurance-rc-professionnelle.component.scss'
})
export class AssuranceRcProfessionnelleComponent {
  title = 'Assurance RC Professionnelle';
  subtitle = 'Protégez votre activité contre les risques de responsabilité civile';
  heroImage = 'assets/images/rcpro.Jpg';
  
  breadcrumbs = [
    { label: 'Professionnels', link: undefined },
    { label: 'RC Professionnelle', link: undefined }
  ];

  prevPage = { title: 'Assurance Santé Professionnels',
    link: '/assurance-sante-professionnels'
  };

  nextPage = { title: 'Assurance Collective Entreprise',
    link: '/assurance-collective-entreprise'
  };

  constructor(private router: Router) {}

  navigateToComparison() {
    this.router.navigate(['/cac/comparaison']);
  }
}
